module.exports = __webpack_public_path__ + "img/usp_icon4.a1e906a8.svg";